import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { Students } from './pages/Students';
import { StudentProfile } from './pages/StudentProfile';
import { Campaigns } from './pages/Campaigns';
import { Letters } from './pages/Letters';
import { Reports } from './pages/Reports';
export function App() {
  const [activePage, setActivePage] = useState('dashboard');
  const [selectedStudentId, setSelectedStudentId] = useState<string | null>(null);
  const handleNavigate = (page: string, id?: string) => {
    setActivePage(page);
    if (id) {
      setSelectedStudentId(id);
    }
  };
  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard onNavigate={handleNavigate} data-id="element-0" />;
      case 'students':
        return <Students onNavigate={handleNavigate} data-id="element-1" />;
      case 'student-profile':
        return <StudentProfile studentId={selectedStudentId || '1'} onBack={() => handleNavigate('students')} data-id="element-2" />;
      case 'campaigns':
        return <Campaigns data-id="element-3" />;
      case 'letters':
        return <Letters data-id="element-4" />;
      case 'reports':
        return <Reports data-id="element-5" />;
      case 'settings':
        return <div className="flex items-center justify-center h-96 text-stone-400" data-id="element-6">
            Settings Placeholder
          </div>;
      default:
        return <Dashboard onNavigate={handleNavigate} data-id="element-7" />;
    }
  };
  return <Layout activePage={activePage} onNavigate={handleNavigate} data-id="element-8">
      {renderPage()}
    </Layout>;
}